import React from 'react';
import { Creditors } from '../components';

export default () => {
    return (
        <Creditors.Home />
    )
}